import React from 'react'
import { DefaultOptions, QueryClient, QueryClientProvider } from '@tanstack/react-query'

interface QueryProviderProps {
  children?: React.ReactNode
}

const defaultQueryClientOptions: DefaultOptions = {
  queries: {
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000,
    retry: 1,
  },
}

export const queryClient = new QueryClient({
  defaultOptions: defaultQueryClientOptions,
})

const QueryProvider: React.FC<QueryProviderProps> = ({ children }) => {
  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
}

export default QueryProvider
